<div class="ap-p-spacing-6">
  <div class="font-weight-normal ap-font-28 ap-px-spacing-1">
    {{ 'admin.title' | translate }}
  </div>
</div>
<div class="ap-px-spacing-4">
  <div class="justify-content-between d-flex w-100 ap-px-spacing-4">
    <ap-tabset
      #tabset
      [type]="'underline'"
      [activeIndex]="tabIndex()"
      (activeIndexChange)="tabChange($event)"
      class="w-90">
      @for (item of adminMenuItems; track $index) {
        <ap-tab
          [label]="
            item.shortTitleTranslateKey ?? item.titleTranslateKey | translate
          " />
      }
    </ap-tabset>
  </div>

  <div class="ap-px-spacing-4 pt-4 mt-2">
    <router-outlet />
  </div>
</div>
